import { TransactionalManagementResult } from "src/app/ui/models/domains/pbm/transactional-management/transactional-management.result";
import { AbstractParser } from "../../parser";
import { parseSale, parseTransactionalManagementResult } from "./transaction-management-parse-functions";

export class TransactionalManagementResultParser extends AbstractParser<TransactionalManagementResult> {
  parse(payload: any) {
    return parseTransactionalManagementResult(payload);
  }
  parseSale(payload: any) {
    return parseSale(payload);
  }
}
